// Libs
import React from 'react'

// CSS
import './styles.scss'

const Spinner = ({ size = 35 }) => {
  return (
    <div className="spinner" style={{ maxWidth: size, maxHeight: size, minWidth: size, minHeight: size }} />
  )
}

export default Spinner
